import mqContainer, { mqConnectMap } from './mqContainer.js';
import channelContainer from './channelContainer.js';
import common from './common.js';
import HashMap from 'hashmap';
import log from '../../../commons/systemCommon/log.js';
import util from '../../../commons/util.js';
import UUID from 'uuid';
let receiveTaskMap = new HashMap();
/**
 * @func  mqInformation
 * @desc  验证mq初始化信息
 * @param {object} mqObject  消息中间件信息
 * @return {boolean} 是否符合要求
 */
function mqInformation(mqObject) {
    let flag = false;
    if (
        !util.isEmpty(mqObject) &&
        !util.isEmpty(mqObject.mqId) &&
        !util.isEmpty(mqObject.ip) &&
        !util.isEmpty(mqObject.webSocketPort) &&
        !util.isEmpty(mqObject.user) &&
        !util.isEmpty(mqObject.password)
    ) {
        flag = true;
    }
    return flag;
}
/**
 * @func  channelInformation
 * @desc  验证channel初始化信息
 * @param {object} channelObject  通道信息
 * @return {boolean} 是否符合要求
 */
function channelInformation(channelObject) {
    let flag = false;
    if (
        !util.isEmpty(channelObject) &&
        !util.isEmpty(channelObject.mqId) &&
        !util.isEmpty(channelObject.channelId) &&
        !util.isEmpty(channelObject.channelName) &&
        !util.isEmpty(channelObject.modeType)
    ) {
        flag = true;
    }
    return flag;
}
export default {
    /**
     * @func  initMQInfo
     * @desc  初始化MQ信息
     * @param {object} mqObject  消息中间件信息
     * @return {object} returnInfo
     */
    initMQInfo(mqObject) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        // 验证并添加MQ信息
        if (mqInformation(mqObject) && mqContainer.addMqInfo(mqObject)) {
            returnInfo.description = window.vue.$t('returnInfo.INIT_SUCCESS');
            returnInfo.ret = window.vue.$t('returnInfo.SUCCESS');
        } else {
            returnInfo.description = window.vue.$t('returnInfo.INIT_FAIL');
        }
        return returnInfo;
    },
    /**
     * @func  cleanMQInfo
     * @desc  清空MQ信息
     * @return {object} returnInfo
     */
    cleanMQInfo() {
        mqContainer.cleanMQInfo();
    },
    /**
     * @func  removeMqInfoById
     * @desc  根据MqId删除MQ信息
     * @param {string} mqId  消息中间件id
     * @return {boolean} 是否成功
     */
    removeMqInfoById(mqId) {
        if (!util.isEmpty(mqId)) {
            mqContainer.removeMqInfoById(mqId);
            return true;
        }
        return false;
    },
    /**
     * @func  initChannelInfo
     * @desc  初始化通道信息
     * @param {object} channelObject  通道信息
     * @return {object} returnInfo
     */
    initChannelInfo(channelObject) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        // 验证并添加通道信息
        if (channelInformation(channelObject) && channelContainer.addChannelInfo(channelObject)) {
            returnInfo.description = window.vue.$t('returnInfo.INIT_SUCCESS');
            returnInfo.ret = window.vue.$t('returnInfo.SUCCESS');
        } else {
            returnInfo.description = window.vue.$t('returnInfo.INIT_FAIL');
        }
        return returnInfo;
    },
    /**
     * @func  cleanChannelInfo
     * @desc  清空通道信息
     * @return {object} returnInfo
     */
    cleanChannelInfo() {
        channelContainer.cleanChannelInfo();
    },
    /**
     * @func  removeChannelInfoById
     * @desc  根据通道Id删除通道信息
     * @param {string} channelId  通道id
     * @return {boolean} 是否成功
     */
    removeChannelInfoById(channelId) {
        if (!util.isEmpty(channelId)) {
            channelContainer.removeChannelInfoById(channelId);
            return true;
        }
        return false;
    },
    /**
     * @func  connectMq
     * @desc  创建MQ连接
     * @param {string} mqId  消息中间件id
     * @return {number} 连接状态标识： 0:连接失败;  1:正在连接; 2:连接成功
     */
    connectMq(mqId) {
        // 该mq正在连接;
        if (mqConnectMap.get(mqId) === window.vue.$t('connectType.CONNECTING_CODE')) {
            return window.vue.$t('connectType.CONNECTING_CODE');
        }
        // 该mq已连接成功
        if (mqContainer.isExistMqInstance(mqId) && mqContainer.getMqInstanceObj(mqId).connected) {
            return window.vue.$t('connectType.SUCCESS_CODE');
        }
        // 该mq未连接，创建连接
        if (mqContainer.connectMq(mqId)) {
            return window.vue.$t('connectType.SUCCESS_CODE');
        }
        return window.vue.$t('connectType.ERROR_CODE');
    },
    /**
     * @func  sendMsg
     * @desc  发送信息
     * @param {string} channelId  通道id
     * @param {string} routingKeys  路由键
     * @param {jsonString} msg  消息JSON串
     * @return {object} returnInfo
     */
    sendMsg(channelId, routingKeys, msg) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.REQUEST_FAIL'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        // 根据通道Id获取该通道所属的MQId
        let mqId = channelContainer.getMqIdByChannelId(channelId);
        if (!util.isEmpty(mqId)) {
            // 判断连接实例是否存在，存在发送信息；不存在需进行连接
            if (mqContainer.isExistMqInstance(mqId) && mqContainer.getMqInstanceObj(mqId).connected) {
                if (channelContainer.isExistChannelInfo(channelId)) {
                    let mqInstanceObj = mqContainer.getMqInstanceObj(mqId);
                    returnInfo = channelContainer.send(mqInstanceObj, channelId, routingKeys, msg);
                }
            } else {
                // 连接成功后发送
                let connected = this.connectMq(mqId);
                if (connected === window.vue.$t('connectType.SUCCESS_CODE')) {
                    if (channelContainer.isExistChannelInfo(channelId)) {
                        let mqInstance = mqContainer.getMqInstanceObj(mqId);
                        returnInfo = channelContainer.send(mqInstance, channelId, routingKeys, msg);
                    }
                } else {
                    setTimeout(function() {
                        if (mqContainer.isExistMqInstance(mqId)) {
                            if (mqContainer.getMqInstanceObj(mqId).connected) {
                                if (channelContainer.isExistChannelInfo(channelId)) {
                                    let mqInstanceObj = mqContainer.getMqInstanceObj(mqId);
                                    returnInfo = channelContainer.send(mqInstanceObj, channelId, routingKeys, msg);
                                }
                            } else {
                                // 创建连接失败
                                if (mqConnectMap.get(mqId) === window.vue.$t('connectType.ERROR_CODE')) {
                                    log.info(common.logInfo.MQ_MANAGER + common.logInfo.SENDMSG + window.vue.$t('returnInfo.SEND_INFO_FAIL') + window.vue.$t('returnInfo.FAILED_TO_CREATE_CONNECTION'));
                                    returnInfo.description = window.vue.$t('returnInfo.FAILED_TO_CREATE_CONNECTION');
                                    returnInfo.ret = window.vue.$t('returnInfo.FAILED_TO_CREATE_CONNECTION_CODE');
                                }
                                // 正在创建连接
                                if (mqConnectMap.get(mqId) === window.vue.$t('connectType.CONNECTING_CODE')) {
                                    log.info(common.logInfo.MQ_MANAGER + common.logInfo.SENDMSG + window.vue.$t('returnInfo.SEND_INFO_FAIL') + window.vue.$t('returnInfo.CREATING_CONNECTION'));
                                    returnInfo.description = window.vue.$t('returnInfo.CREATING_CONNECTION');
                                    returnInfo.ret = window.vue.$t('returnInfo.CREATING_CONNECTION_CODE');
                                }
                            }
                        } else {
                            // 未创建连接
                            log.info(common.logInfo.MQ_MANAGER + common.logInfo.SENDMSG + window.vue.$t('returnInfo.SEND_INFO_FAIL') + window.vue.$t('returnInfo.NO_CONNECTION_CREATED'));
                            returnInfo.description = window.vue.$t('returnInfo.NO_CONNECTION_CREATED');
                            returnInfo.ret = window.vue.$t('returnInfo.NO_CONNECTION_CREATED_CODE');
                        }
                    }, 2000); // 延迟2秒
                }
            }
        }
        return returnInfo;
    },
    /**
     * @func  receiveMsg
     * @desc  接受消息
     * @param {string} channelId  通道id
     * @param {string} routingKeys  路由键
     * @param {string} reciveCallback  回调函数
     * @param {string} subscribeId  订阅id  可选参数
     * @return {function}  reciveCallback 回调函数
     */
    receiveMsg(channelId, routingKeys, reciveCallback, subscribeId) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.REQUEST_FAIL'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        // 根据通道Id获取该通道所属的MQId
        let mqId = channelContainer.getMqIdByChannelId(channelId);
        if (!util.isEmpty(mqId)) {
            let newSubscribeId = UUID.v1(); // 1、uuid.v1(); -->基于时间戳生成 2、uuid.v4(); -->生成随机数
            if (subscribeId) {
                newSubscribeId = subscribeId;
            }
            // 接收消息任务对象,用于断网恢复机制
            let receiveTask = {
                subscribeId: newSubscribeId,
                mqId: mqId,
                channelId: channelId,
                reciveCallback: reciveCallback,
                routingKeys: routingKeys
            };
            // 记录订阅任务
            if (receiveTaskMap.has(newSubscribeId)) {
                let list = util.clone(receiveTaskMap.get(newSubscribeId));
                let flag = false;
                for (var i = 0; i < list.length; i++) {
                    if (
                        receiveTask.subscribeId == list[i].subscribeId &&
                        receiveTask.mqId == list[i].mqId &&
                        receiveTask.channelId == list[i].channelId &&
                        receiveTask.routingKeys == list[i].routingKeys
                    ) {
                        flag = true;
                        break;
                    }
                }
                if (!flag) {
                    list.push(receiveTask);
                    receiveTaskMap.set(newSubscribeId, list);
                }
            } else {
                let list = [];
                list.push(receiveTask);
                receiveTaskMap.set(newSubscribeId, list);
            }
            // 判断连接实例是否存在，存在订阅信息；不存在需进行连接
            if (mqContainer.isExistMqInstance(mqId) && mqContainer.getMqInstanceObj(mqId).connected) {
                if (channelContainer.isExistChannelInfo(channelId)) {
                    let mqInstanceObj = mqContainer.getMqInstanceObj(mqId);
                    returnInfo = channelContainer.subscribe(mqInstanceObj, channelId, routingKeys, reciveCallback, newSubscribeId);
                }
            } else {
                // 连接成功后订阅消息
                let connected = this.connectMq(mqId);
                if (connected === window.vue.$t('connectType.SUCCESS_CODE')) {
                    if (channelContainer.isExistChannelInfo(channelId)) {
                        let mqInstance = mqContainer.getMqInstanceObj(mqId);
                        returnInfo = channelContainer.subscribe(mqInstance, channelId, routingKeys, reciveCallback, subscribeId);
                    }
                } else {
                    setTimeout(function() {
                        if (mqContainer.isExistMqInstance(mqId)) {
                            if (mqContainer.getMqInstanceObj(mqId).connected) {
                                if (channelContainer.isExistChannelInfo(channelId)) {
                                    let mqInstanceObj = mqContainer.getMqInstanceObj(mqId);
                                    returnInfo = channelContainer.subscribe(mqInstanceObj, channelId, routingKeys, reciveCallback, newSubscribeId);
                                }
                            } else {
                                // 创建连接失败
                                if (mqConnectMap.get(mqId) === window.vue.$t('connectType.ERROR_CODE')) {
                                    log.info(common.logInfo.MQ_MANAGER + common.logInfo.RECEIVEMSG + window.vue.$t('returnInfo.SUBSCRIBE_INFO_FAIL') + window.vue.$t('returnInfo.FAILED_TO_CREATE_CONNECTION'));
                                    returnInfo.description = window.vue.$t('returnInfo.FAILED_TO_CREATE_CONNECTION');
                                    returnInfo.ret = window.vue.$t('returnInfo.FAILED_TO_CREATE_CONNECTION_CODE');
                                }
                                // 正在创建连接
                                if (mqConnectMap.get(mqId) === window.vue.$t('connectType.CONNECTING_CODE')) {
                                    log.info(common.logInfo.MQ_MANAGER + common.logInfo.RECEIVEMSG + window.vue.$t('returnInfo.SUBSCRIBE_INFO_FAIL') + window.vue.$t('returnInfo.CREATING_CONNECTION'));
                                    returnInfo.description = window.vue.$t('returnInfo.CREATING_CONNECTION');
                                    returnInfo.ret = window.vue.$t('returnInfo.CREATING_CONNECTION_CODE');
                                }
                            }
                        } else {
                            // 未创建连接
                            log.info(common.logInfo.MQ_MANAGER + common.logInfo.RECEIVEMSG + window.vue.$t('returnInfo.SUBSCRIBE_INFO_FAIL') + window.vue.$t('returnInfo.NO_CONNECTION_CREATED'));
                            returnInfo.description = window.vue.$t('returnInfo.NO_CONNECTION_CREATED');
                            returnInfo.ret = window.vue.$t('returnInfo.NO_CONNECTION_CREATED_CODE');
                        }
                    }, 2000); // 延迟2秒
                }
            }
        }
        return returnInfo;
    },
    /**
     * @func  unSubscribeMsg
     * @desc  取消订阅消息
     * @param {string} subscribeId  订阅id
     * @return {object}  returnInfo
     */
    unSubscribeMsg(subscribeId, routingKeys) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (!util.isEmpty(subscribeId)) {
            returnInfo = channelContainer.unsubscribe(subscribeId, routingKeys);
        } else {
            log.error(common.logInfo.MQ_MANAGER + common.logInfo.UNSUBSRCIBEMSG + window.vue.$t('returnInfo.PARAMETER_ERROR'));
        }
        return returnInfo;
    },
    /**
     * @func  getReceiveTask
     * @desc  获取历史订阅任务消息
     * @return {object} subscribeObjs 订阅对象数组
     */
    getReceiveTask() {
        return receiveTaskMap.values();
    },
    /**
     * @func  reSubscribe
     * @desc  重新订阅
     * @param {string} mqId  MQid
     * @return {object} null
     */
    reSubscribe(mqId) {
        let receiveTaskAllArr = receiveTaskMap.values();
        for (let m = 0; m < receiveTaskAllArr.length; m++) {
            let receiveTaskArr = receiveTaskAllArr[m];
            for (let i = 0; i < receiveTaskArr.length; i++) {
                if (receiveTaskArr[i].mqId === mqId && channelContainer.isExistSubscribeObj(receiveTaskArr[i].subscribeId + receiveTaskArr[i].routingKeys)) {
                    // 重新订阅
                    this.receiveMsg(receiveTaskArr[i].channelId, receiveTaskArr[i].routingKeys, receiveTaskArr[i].reciveCallback, receiveTaskArr[i].subscribeId);
                }
            }
        }
    },
    /**
     * @func  disconnectMq
     * @desc  根据mqId断开MQ连接
     * @param {string} mqId 消息中间件id
     * @return {boolean} 是否成功
     */
    disconnectMq() {
        let list = mqContainer.getAllMqId();
        for (let i = 0; i < list.length; i++) {
            mqContainer.disconnectMq(list[i]);
        }
        channelContainer.cleanChannelInfo();
        channelContainer.subscribeObjMapInfo();
        mqContainer.cleanMQInfo();
        mqContainer.mqConnectMapInfo();
        receiveTaskMap.clear();
    }
};
